


import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice"
import PhoneInput from "react-phone-input-2"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const SmsDogrulamaPhoneNumberInput = ({item, data, setData, keyData, name, labelText, addLoad}) => {
    
    const dispatch = useDispatch()
    const [phoneValue, setPhoneValue] = useState("")

    // const handleChange = (e) => {
    //     const value = e.target.value

    //     const updatedList = data.map((routeItem) => {
    //         if(routeItem.id === item.id){
    //             if(addLoad){
    //                 console.log("asdads");
                    
    //                 dispatch(updateRouteItem({id: item.id, smsVerificationPhoneNumber: phoneValue}))
    //             }
    //             return {...item, [keyData]: value}
    //         }
    //         else{
    //             return routeItem
    //         }
    //     })
    //     setData(updatedList)
    // }

    useEffect(() => {
        if (item.smsVerificationPhoneNumber) {
            const formattedPhoneNumber = (item.smsVerificationPhoneNumber.startsWith("+90") || item.smsVerificationPhoneNumber.startsWith("90")) ? `${item.smsVerificationPhoneNumber}` : `90${item.smsVerificationPhoneNumber}`;
            setPhoneValue(formattedPhoneNumber);
        }
    }, []);

    useEffect(() => {
        const updatedList = data.map((routeItem) => {
            if(routeItem.id === item.id){
                if(addLoad){
                    
                    dispatch(updateRouteItem({id: item.id, smsVerificationPhoneNumber: phoneValue}))
                }
                return {...item, [name]: phoneValue}
            }
            else{
                return routeItem
            }
        })
        setData(updatedList)
    },[phoneValue])

  return (
    <Container value={true} radius={"5px"}>
        {/* <input type="text" id={"text"} onChange={handleChange} value={item.smsVerificationPhoneNumber} name={"text"}/>  */}
        <PhoneInput name={name} onChange={setPhoneValue} value={phoneValue} country={"tr"} countryCodeEditable={false} />

        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default SmsDogrulamaPhoneNumberInput